/**
 * Sticky ATC — PDP-only bar: product thumbnail, active variant, price,
 * add-to-cart shortcut.
*/

const HEADER_SELECTOR = '#header.wt-header--sticky';
const ATC_BUTTON_SELECTOR = '.js-add-to-cart.product-form__submit';
const MOBILE_BREAKPOINT = 899;

let initialized = false;

function initStickyAtc() {
  const enabled = document.body.dataset.pdmPdpStickyAtc;
  if (initialized || enabled !== 'true') return;
  initialized = true;

  const header = document.querySelector(HEADER_SELECTOR);
  const mainAtcButton = document.querySelector(ATC_BUTTON_SELECTOR);
  const stickyBar = document.querySelector('.sticky-atc');
  const stickyButton = stickyBar?.querySelector('.sticky-atc__button');

  if (!header || !mainAtcButton || !stickyBar || !stickyButton) {
    return;
  }

  function addToCart() {
    mainAtcButton.click();
  }

  stickyButton.addEventListener('click', () => {
    if (stickyButton.hasAttribute('disabled')) return;
    addToCart();
  });

  // iOS collapsing toolbar: `bottom: 0` sticks to the layout viewport, which stays
  // tall after the toolbar hides, leaving a gap under the bar.
  if (window.visualViewport) {
    const updateViewportOffset = () => {
      const offset = window.innerHeight - window.visualViewport.height - window.visualViewport.offsetTop;
      stickyBar.style.setProperty('--sticky-atc-offset', `${Math.max(offset, 0)}px`);
    };

    updateViewportOffset();
    window.visualViewport.addEventListener('resize', updateViewportOffset);
    window.visualViewport.addEventListener('scroll', updateViewportOffset);
  }

  // Native visibility trigger: show once the main ATC button is hidden behind the sticky header
  if (window.innerWidth <= MOBILE_BREAKPOINT) {
    const headerHeight = header.getBoundingClientRect().height;
    const observer = new IntersectionObserver(
      ([entry]) => {
        stickyBar.classList.toggle('sticky-atc--active', !entry.isIntersecting);
      },
      { rootMargin: `-${headerHeight}px 0px 0px 0px`, threshold: 0 }
    );
    observer.observe(mainAtcButton);
  }

  // Keep the sticky bar in sync with the variant selected on the main product form
  const variantsDataEl = document.querySelector('[data-sticky-atc-variants]');
  const variantsData = variantsDataEl ? JSON.parse(variantsDataEl.textContent) : {};
  const idInput = mainAtcButton.closest('form')?.querySelector('[name="id"]');

  function syncVariant() {
    if (!idInput) return;
    const variant = variantsData[idInput.value];
    if (!variant) return;

    const image = stickyBar.querySelector('.sticky-atc__image-img');
    const variantLabel = stickyBar.querySelector('.sticky-atc__variant');
    const price = stickyBar.querySelector('.sticky-atc__price');
    const comparePrice = stickyBar.querySelector('.sticky-atc__compare-price');

    if (image && variant.image) {
      image.removeAttribute('srcset');
      image.src = variant.image;
    }
    if (variantLabel) variantLabel.textContent = variant.options;
    if (price) price.textContent = variant.price;

    if (comparePrice) {
      comparePrice.hidden = !variant.comparePrice;
      if (variant.comparePrice) comparePrice.textContent = variant.comparePrice;
    }

    stickyButton.dataset.variantId = idInput.value;
    stickyButton.toggleAttribute('disabled', !variant.available);
    stickyButton.classList.toggle('sticky-atc__button--disabled', !variant.available);
    stickyButton.textContent = variant.available
      ? stickyButton.dataset.labelAvailable
      : stickyButton.dataset.labelSoldOut;
  }

  document.addEventListener('variantChangeEnd', syncVariant);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initStickyAtc);
} else {
  initStickyAtc();
}

// GrowthBook resolves the flag asynchronously — retry once it's ready
document.addEventListener('pdp-sticky-atc:updated', initStickyAtc);
